import api from '../../plugins/api';

// api.get ÑÐ°Ð¼ ÐºÐ»Ð°Ð´ÑÑ Ð²ÑÐ¾ÑÐ¾Ð¹ Ð°ÑÐ³ÑÐ¼ÐµÐ½Ñ Ð² params: { dealId } Ð´Ð°ÑÑ ?dealId=13.
const getClientUploadStatus = ({ dealId }) => {
  return api.get('/api/crm/clientUpload/status', { dealId });
};

export default getClientUploadStatus;
